import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import { Strong, Visible } from 'main/ui'
import { IRangeProps } from 'main/ui/slider/RangeSlider'
import TimeRangeSlider from 'main/ui/slider/TimeRangeSlider'
import { getTimeAsString, getTimeInMinutes } from 'main/ui/slider/util'
import { IFilters } from 'main/util/search'
import { useTranslation } from 'react-i18next'
import {
  Apply,
  Clear,
  FilterFormContainer,
  FilterFormSubmitContainer,
} from '../../common/FilterForm.styles'
import { ISearchFormProps } from '../../types'

const maxValue = 12 * 60
const minValue = 0

const PRE = `${i18nKeyPrefix}-FILTERS-DROP-OFF-FORM`

export default function FilterForm(props: ISearchFormProps) {
  const { filters, onChangeFilters, onRequestCloseForm } = props

  const [params, setParams] = React.useState<IFilters>({ ...filters })
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <FilterFormContainer>
      <Visible lg xl>
        <Fields params={params} onChangeParams={setParams} />
        <FilterFormSubmitContainer>
          <Clear data-pendo="hoursFilter-dropOffTime-clear" onClick={() => handleClear()}>
            {t(`${PRE}-CLEAR`)}
          </Clear>
          <Apply data-pendo="hoursFilter-dropOffTime-apply" onClick={() => handleApply()}>
            {t(`${PRE}-APPLY`)}
          </Apply>
        </FilterFormSubmitContainer>
      </Visible>
    </FilterFormContainer>
  )

  function handleApply() {
    onRequestCloseForm()
    onChangeFilters({
      ...filters,
      dropOffStartsAt: params.dropOffStartsAt,
      dropOffEndsAt: params.dropOffEndsAt,
    })
  }

  function handleClear() {
    setParams({ ...params, dropOffStartsAt: null, dropOffEndsAt: null })
  }
}

interface IFieldsProps {
  params: IFilters
  onChangeParams: (params: IFilters) => void
}

export function Fields(fieldsProps: IFieldsProps) {
  const { params, onChangeParams } = fieldsProps
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <>
      <Strong>{t(`${PRE}-LABEL`)}</Strong>
      <TimeRangeSlider
        data-pendo="hoursFilter-dropOffTime"
        maxValue={maxValue}
        minValue={minValue}
        step={15}
        value={{
          max: params.dropOffEndsAt ? getTimeInMinutes(params.dropOffEndsAt) : maxValue,
          min: params.dropOffStartsAt ? getTimeInMinutes(params.dropOffStartsAt) : minValue,
        }}
        onChange={value => handleChange(value)}
      />
    </>
  )

  function handleChange(value: IRangeProps) {
    const dropOffEndsAt =
      value.max >= maxValue && value.min <= minValue ? null : getTimeAsString(value.max)
    const dropOffStartsAt =
      value.min <= minValue && value.max >= maxValue ? null : getTimeAsString(value.min)

    onChangeParams({ ...params, dropOffEndsAt, dropOffStartsAt })
  }
}
